module.exports = __webpack_public_path__ + "static/media/BDLogo.9020c63b.svg";